import { render, staticRenderFns } from "./ReceivingAddress.vue?vue&type=template&id=6eb4a58f&scoped=true&"
import script from "./ReceivingAddress.vue?vue&type=script&lang=js&"
export * from "./ReceivingAddress.vue?vue&type=script&lang=js&"
import style0 from "./ReceivingAddress.vue?vue&type=style&index=0&id=6eb4a58f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb4a58f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6eb4a58f')) {
      api.createRecord('6eb4a58f', component.options)
    } else {
      api.reload('6eb4a58f', component.options)
    }
    module.hot.accept("./ReceivingAddress.vue?vue&type=template&id=6eb4a58f&scoped=true&", function () {
      api.rerender('6eb4a58f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PersonalCenter/ReceivingAddress/ReceivingAddress.vue"
export default component.exports